import { FC } from 'react';
import { useTranslation } from '../../../../../utils/useTranslation';
import { IconPlus } from '../../../../icon/IconPlus';
import { Box } from '../../../../layout/Box';
import { DataTestId } from '../../../../layout/DataTestIdWrapper';
import { Stack } from '../../../../layout/Stack';
import { Typography } from '../../../../typography/Typography';
import { ListItem } from '../../styles';
import { CollectionListItem } from '../CollectionListItem/CollectionListItem';
import { CollectionListItemSkeleton } from '../CollectionListItemSkeleton/CollectionListItemSkeleton';
import { ExistentCollectionContentProps } from './types';

export const ExistentCollectionContent: FC<ExistentCollectionContentProps> = ({
    onAddClick,
    isCollectionsLoading,
    collections,
    onSaveClick,
}) => {
    const t = useTranslation();

    const renderItem = (index: number) => {
        const collection = collections[index];

        if (!collection) {
            return <CollectionListItemSkeleton key={index} />;
        }

        return (
            <CollectionListItem
                key={collection.id}
                collection={collection}
                onClick={() => {
                    onSaveClick(collection.id);
                }}
            />
        );
    };

    return (
        <Box width="100%" height="100%">
            <Box width="100%" px={2} py={1}>
                <ListItem p={1} role="button" onClick={onAddClick}>
                    <Box
                        p={1.5}
                        borderRadius={1}
                        backgroundColor="var(--control-secondary-background)"
                    >
                        <IconPlus color="var(--color-primary)" fontSize={24} />
                    </Box>
                    <Typography variant="body" dataTestId={DataTestId.ADD_NEW_COLLECTION}>
                        {t('Добавить в новую коллекцию')}
                    </Typography>
                </ListItem>
            </Box>

            <Stack
                p={2}
                pt={0}
                overflowY="auto"
                count={isCollectionsLoading ? 5 : collections.length}
                width="100%"
                spacing={2}
                renderItem={renderItem}
            />
        </Box>
    );
};
